// no-op
import ToggleSwitch from '../../../ui/ToggleSwitch/ToggleSwitch'
import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Link as LinkIcon, Key, Lock } from 'lucide-react'

export default function DestinationSection({ form, styles }: SectionProps) {
    const { watch, setValue } = form
    return (
        <>
            <div className={styles.field}>
                <SecureInput
                    fieldType="name"
                    label="Destination Name"
                    value={watch('destination.name') || ''}
                    onChange={(value) => setValue('destination.name', value)}
                    className={styles.input}
                />
            </div>

            <div className={styles.field}>
                <SecureInput
                    fieldType="text"
                    label="Subaccount (optional)"
                    value={watch('destination.subaccount') || ''}
                    onChange={(value) => setValue('destination.subaccount', value)}
                    className={styles.input}
                />
            </div>

            <div className={styles.field}>
                <label className={styles.label}>Destination Auth Mode</label>
                <select
                    value={watch('destination.auth') || 'OAuth2ClientCredentials'}
                    onChange={(e) => setValue('destination.auth', e.target.value)}
                    className={styles.input}
                >
                    <option value="OAuth2ClientCredentials">OAuth2 Client Credentials</option>
                    <option value="OAuth2UserTokenExchange">OAuth2 User Token Exchange (OBO)</option>
                    <option value="OAuth2SAMLBearerAssertion">OAuth2 SAML Bearer Assertion</option>
                </select>
            </div>

            <div className={styles.field}>
                <label className={styles.label}>Forward Auth Token</label>

                <div className={styles.checkboxLabel}>
                    <ToggleSwitch
                        checked={!!watch('destination.forward_auth_token')}
                        onChange={(checked) => setValue('destination.forward_auth_token', checked)}
                    />
                </div>
            </div>

            <div className={styles.field}>
                <SecureInput
                    fieldType='text'
                    label="Client ID"
                    icon={<Key size={16} />}
                    value={watch('oauth.client_id') || ''}
                    onChange={(value) => setValue('oauth.client_id', value)}
                    autoComplete="new-client-id"
                    className={styles.input}
                />
            </div>

            <div className={styles.field}>
                <SecureInput
                    fieldType="password"
                    label="Client Secret"
                    icon={<Lock size={16} />}
                    value={watch('oauth.client_secret') || ''}
                    onChange={(value) => setValue('oauth.client_secret', value)}
                    autoComplete="new-password"
                    skipPasswordValidation={true}
                    className={styles.input}
                />
            </div>

            <div className={styles.field}>
                <SecureInput
                    fieldType="url"
                    label="Token URL"
                    icon={<LinkIcon size={16} />}
                    value={watch('oauth.token_url') || ''}
                    onChange={(value) => setValue('oauth.token_url', value)}
                    className={styles.input}
                />
            </div>
        </>
    )
}
